module.exports = __webpack_public_path__ + "static/media/a2.59f64898.jpg";